import {AutoComplete, Button, Col, Form, Input, message, Modal, Popover, Result, Row, Spin, Tooltip} from "antd";
import React, {useCallback, useContext, useState} from "react";
import cls from "classnames";
import {ExchangeButton, FormGroup, FormInput, FormInputNumber, FormLabel, Layout} from "./styles";
import GameTargetPicker from "../GameTargetPicker";
import {http, isErrorException} from "@firefly/fly-http";
import UserContext from "../../../component/user/context/UserContext";
import {useQuery} from "react-query";
import {useCoinAccountRechargeGameMutation} from "../../hook/coin";
import {GameTarget} from "../../../typing";
import VerifyUserMobileNumberModal from "../../../connect/gamepay/VerifyUserMobileNumberModal";
import useVerifyUserMobilePrepareQuery from "../../../connect/gamepay/useVerifyUserMobilePrepareQuery";
import {useThrottleFn} from "@firefly/fly-hook";
// import Toast from "../../../support/Toast";

export interface ExchangeProps {
    gameId?: string;
    vipServers: string[];
    className?: string;
    onClick?: () => boolean;
}
function Exchange(props: ExchangeProps) {
    const {
        gameId,
        vipServers,
        className,
        onClick,
    } = props;
    const {
        current,
        authenticated,
        authenticate,
    } = useContext(UserContext);

    const {
        isLoading,
        mutateAsync,
    } = useCoinAccountRechargeGameMutation(gameId!);

    const [completed, setCompleted] = useState<any | false>(false);
    const [target, setTarget] = useState<GameTarget | null>(null);
    // const [serverId, setServerId] = useState<string>();
    const [amount, setAmount] = useState<number | null>(null);
    const [error, setError] = useState<string | null>(null);
    const {
        prepare
    } = useVerifyUserMobilePrepareQuery(current?.uid);
    const [verify, setVerify] = useState<{
        next: (token: string) => Promise<void> | void
    } | null>(null);

    const submit = useThrottleFn(() => {
        if (!target) {
            return;
        }
        const serverId = target!.serverId;
        return mutateAsync({
            serverId: serverId!,
            amount: amount!,
        }).then(() => {
            setCompleted(true);
            setTarget(null)
            setAmount(null);
        }, (reason) => {
            if (isErrorException(reason)) {
                const {
                    error: errorInfo
                } = reason;
                setError(`兑换失败: ${errorInfo.message??errorInfo.code}`)
            }
        }).finally(() => {

        })
    }, {
        wait: 1000,
        leading: true,
        trailing: false,
    });
    const onSubmit = useThrottleFn(() => {
        setError(null)
        if (!current) {
            authenticate();
            return;
        }
        if (onClick?.() === false) {
            return;
        }
        if (!target?.serverId) {
            setError("请选择区服")
            // message.error("请选择区服").then()
            return;
        }
        if (!amount) {
            setError("请选择输入兑换金额")
            // message.error("请选择输入兑换金额").then();
            return;
        }


        function next() {
            submit.run();
        }

        if (prepare?.mobile) {
            setVerify({
                next: next
            })
            return ;
        }
        return next();
    }, {
        wait: 1000,
        leading: true,
        trailing: false,
    })
    // function submit() {
    //
    // }
    function renderContent() {
        return <FormGroup>
            <Form.Item labelCol={{span: 10}} label={`请选择您要兑换的区服`}>
                <GameTargetPicker
                    key={(vipServers??[]).join('-')}
                    gameId={gameId}
                    username={current?.username}
                    serversFn={(gameId) => {
                        if (!vipServers) {
                            return Promise.resolve([]);
                        }
                        return http.get(`https://niu.niuxyx.com/api/niux-compatible/games/${gameId}/servers`).then((servers) => {
                            if (~vipServers.indexOf('*')) {
                                return servers;
                            }
                            return servers.filter((server: any) => {
                                return ~vipServers.indexOf(server.serverId);
                            })
                        })
                    }}
                    rolesFn={(_gameId, _serverId, queryFn) => {
                        return queryFn()
                    }}
                    value={target}
                    onChange={setTarget}
                />
            </Form.Item>
            <Form.Item labelCol={{span: 10}} label={`请输入要兑换的金额`} >
                <FormInputNumber stringMode style={{
                    width: 200
                }}
                                 // suffix={"元"}
                 // decimalSeparator={"1"}
                 value={amount}
                                 step={1}
                                 parser={((v: string) => {
                                     return v ? parseInt(v) : null;
                                 }) as any}
                 onChange={(v: string | number | null) => {
                    setAmount(v as number)
                }}
                />
            </Form.Item>
            <Form.Item wrapperCol={{offset: 7}} style={{
                paddingTop: 18
            }} hasFeedback={!!error} validateStatus={error ? "error" : undefined} help={error} >
                <ExchangeButton
                    disabled={isLoading}
                    loading={isLoading}
                    style={{width: 160, height: 38}}
                    type={"primary"}
                    onClick={() => {
                        onSubmit.run()
                        return;
                    }}
                >
                    立即兑换
                </ExchangeButton>
            </Form.Item>
        </FormGroup>
    }

    return <Layout className={cls("exchange", className)}>
        {renderContent()}
        <Modal open={completed} footer={null} destroyOnClose>
            <Result
                status="success"
                title="兑换成功！游戏币已经发放至游戏内，请进入游戏查收~"
                // subTitle="Order number: 2017182818828182881 Cloud server configuration takes 1-5 minutes, please wait."
                extra={[
                    <Button type="primary" onClick={() => {
                        setCompleted(false)
                    }}>
                        关闭
                    </Button>,
                    // <Button key="buy">Buy Again</Button>,
                ]}
            />
        </Modal>
        {current && prepare ? (
          <VerifyUserMobileNumberModal
            top={"10%"}
            open={!!verify}
            userid={current?.uid}
            mobile={prepare.mobile}
            onOk={(value) => {
                verify!.next(value.token);
                setVerify(null)
            }}
            onCancel={() => {
                setVerify(null);
            }}
            destroyOnClose
          />
        ) : null}
    </Layout>
}

export default Exchange;